<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("report_wms_summary") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card
                    class="no-border-card"
                    body-classes="px-0 pb-1"
                    footer-classes="pb-2"
                >
                    <template slot="header">
                        <div class="row">
                            <div class="col-md-2">
                                <base-input>
                                    <flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        :config="{ allowInput: true }"
                                        class="form-control datepicker"
                                        v-model="startDate"
                                    >
                                    </flat-picker>
                                </base-input>
                            </div>

                            <div class="col-md-2">
                                <base-input>
                                    <flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        :config="{ allowInput: true }"
                                        class="form-control datepicker"
                                        v-model="endDate"
                                    >
                                    </flat-picker>
                                </base-input>
                            </div>

                            <div class="col-md-2">
                                <base-input>
                                    <el-select
                                        v-model="paymentMethodType"
                                        :placeholder="$t('payment_method_type')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in PaymentMethodTypeTable"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

                            <div class="col-md-2">
                                <base-input>
                                    <el-select
                                        v-model="orderStatus"
                                        :placeholder="$t('menu.order_status')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in OrderStatusTable"
                                            :key="option.ID"
                                            :label="option.Name"
                                            :value="option.ID"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

							<div class="col-md-2">
								<base-input  >
								<el-select v-model="saleChannelType" :placeholder="$t('sale_channel')" filterable >
									<el-option
										v-for="option in SaleChannelTypeTableWithAll"
										:key="option.id"
										:label="option.name"
										:value="option.id"
									>
									</el-option>
								</el-select>
							</base-input>
                            </div>

							<div class="col-md-2">
                                <base-input>
                                    <el-select
                                        v-model="userId"
                                        :placeholder="$t('menu.user')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in OptionUserTable"
                                            :key="option.UserID"
                                            :label="option.fname + ' ' + option.lname"
                                            :value="option.UserID"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

							<div class="col-md-2">
                                <base-input>
                                    <el-select
                                        v-model="boProductId"
                                        :placeholder="$t('menu.product')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in ProductTableWithAll"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

							<div class="col-md-2">
                                <base-input>
                                    <el-select
                                        v-model="boPlatformId"
                                        :placeholder="$t('platform')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in PlatformTable"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>


                            <div class="col-auto">
                                <base-button
                                    size="md"
                                    type="primary"
                                    @click="handleSearch()"
                                >
                                    Search
                                </base-button>
                                <base-button
                                    size="md"
                                    type="primary"
                                    @click="handleDownloadXLSX()"
                                >
                                    Export
                                </base-button>
                            </div>
                        </div>
                    </template>
                    <div>
                        <el-table
                            :data="queriedData"
                            row-key="id"
                            header-row-class-name="thead-light"
                            @sort-change="sortChange"
                            @selection-change="selectionChange"
                        >
                            <el-table-column
                                v-for="column in tableColumns"
                                :key="column.label"
                                v-bind="column"
                            >
                            </el-table-column>

                            <!-- <el-table-column
				  min-width="200px"
				  align="right"
				  :label="$t('actions')"
				>
				  <div slot-scope="{ $index, row }" class="d-flex">
					<base-button
					  @click.native="handleDetail($index, row)"
					  class="edit"
					  type="warning"
					  size="sm"
					  icon
					>
					  <i class="text-dtac-bt fa fa-edit"></i>
					  Detail
					</base-button>
				  </div>
				</el-table-column> -->
                        </el-table>
                    </div>
                    <div
                        slot="footer"
                        class=" col-12 d-flex justify-content-center justify-content-sm-between flex-wrap "
                        v-if="queriedData.length != 0"
                    >
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                                <span v-if="selectedRows.length">
                                    - &nbsp; &nbsp; {{ selectedRows.length }}
                                    {{ $t("row_select") }}
                                </span>
                            </p>
                        </div>
                        <base-pagination
                            class="pagination-no-border"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="total"
                        >
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>
    </div>
</template>
<script>

import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
  import { read, utils, writeFile } from 'xlsx'

export default {
    mixins: [clientPaginationMixin],
    components: {
        flatPicker,
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            tableData: "Report/getReportWmsSummary",
            PaymentMethodTypeTable: "PaymentMethod/getPaymentMethodTypeTableWithAll",
            OrderStatusTable: "Order/OrderStatusTableWithAllPayment",
            reportDatum: "Report/getReportDatum",
            UserTable: "User/getData",
			ProductTable: "Product/getData",
			PlatformTable : "Order/getPlatformTableWithAll",
        }),
		SaleChannelTypeTable(){
			return [
				{id:1,name:"บริษัท"},
				{id:2,name:"ตัวแทน"},
			]
		},
		OptionUserTable: function() {
			return [{ UserID: 0, fname: "-- พนักงาน --",lname:"" }, ...this.UserTable]
        },
		SaleChannelTypeTableWithAll(){
			return [{id:0,name:"-- ประเภทช่องทางการขาย -- "}].concat(this.SaleChannelTypeTable);
		},
		ProductTableWithAll(){
			return [{id:0,name:"-- สินค้าและโปรโมชั่น -- "}].concat(this.ProductTable);
		},
        tableColumns: function() {
            return [
                {
                    prop: "name",
                    label: this.$t("product"),
                    minWidth: 90,
                    sortable: true
                },
                {
                    prop: "amount",
                    label: this.$t("product_amount"),
                    minWidth: 100,
                    sortable: true
                }
            ];
        }
    },
    data() {
        return {
            propsToSearch: ["name"],
            selectedRows: [],
            SearchData: "",
            startDate: "",
            endDate: "",
            paymentMethodType: 0,
            orderStatus: 0,
			saleChannelType:0,
			userId : 0,
			boProductId : 0,
			boPlatformId : 0,
        };
    },
    mounted() {

        this.listUser();
		this.listProduct({status:1,platform_id:1});

		this.startDate = moment()
			.add(-30, "days")
			.format("YYYY-MM-DD");
		this.endDate = moment().format("YYYY-MM-DD");

		console.log("Date ", this.startDate)
		

		try {
			if (this.$route.params.startDate != null) {
				console.log("Param ",this.$route.params)
				let p = this.$route.params
				this.SearchData = p.SearchData
				this.startDate = p.startDate
				this.endDate = p.endDate
				this.paymentMethodType = p.paymentMethodType
				this.orderStatus = p.orderStatus
				this.saleChannelType = p.saleChannelType
				this.userId  = p.userId
				this.boProductId = p.boProductId
			}
		} catch (err) {
			// swal fire error
		}


        this.handleSearch();
    },
    methods: {
        ...mapActions({
            listData: "Report/listReportSummaryWmsProduct",
            listUser: "User/listData",
            listProduct: "Product/listData",
        }),
        async handleSearch() {

			
            let params = {
                time_from: this.startDate,
                time_to: this.endDate,
                payment_method_type: this.paymentMethodType,
				order_status: this.orderStatus == 0 ? [111,112,114,121,122,130] : [this.orderStatus] ,
				sale_channel_type_id : this.saleChannelType,
				user_id : this.userId,
				bo_product_id : this.boProductId,
				platform_id : this.boPlatformId
            };
            await this.listData(params);
			this.sortChange({prop:"Cnt",order:""})
        },
        handleExport() {
            const csvString = [
                ["สินค้า", "จำนวนสินค้า"],
                ...this.tableData.map(item => [
                    item.name,
                    item.amount
                ])
            ]
                .map(e => e.join(","))
                .join("\n");

            let csvContent = "data:text/csv;charset=utf-8,\ufeff" + csvString;
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "report_user_product.csv");
            document.body.appendChild(link); // Required for FF

            link.click();
        },

		async handleDownloadXLSX(index,row){

			let dataExport = this.tableData.map((item)=>{
				return {
                    "สินค้า" : item.name,
                    "จำนวนสินค้า" : item.amount,
                }
			})

			const dataWS = utils.json_to_sheet(dataExport)
			const wb = utils.book_new()
			utils.book_append_sheet(wb, dataWS)
			writeFile(wb,`wms_summary_${this.startDate}_${ this.endDate}.xlsx`)

		},

        handleDetail(index, row) {
            // this.$router.push("/wms/historydetail/" + row.ID);
            window.open("/#/wms/historydetail/" + row.ID);
        },
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows;
        }
    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
